import { type ActiveUser } from '@bbkAdminRedux/app/reducers';
import { preauthBbkApiSlice } from '@bbkAdminRedux/rtkq/preauth.bbkApi.slice';

/**
 * Non-caching post-login validation of `/api/current_user`.
 *
 * Modeled as a mutation on the pre-auth API (not the guarded `bbkApiSlice`) so
 * it:
 * - never writes the global `getCurrentUser` query cache, so it does not flip
 *   `selectAuthStatus`/`selectUser` to authenticated while still on the sign-in
 *   page (which would mount the logged-in tree prematurely);
 * - is not blocked by the signed-out request guard on `bbkApiSlice`;
 * - is not treated as a session-ending action by the unauthorized-redirect
 *   middleware (its reducerPath is neither `bbkApi` nor `internalBbkApi`), so a
 *   transient 401 during sign-in retries instead of forcing a reload.
 */
export const preauthCurrentUserSlice = preauthBbkApiSlice.injectEndpoints({
  endpoints: (build) => ({
    validateCurrentUser: build.mutation<ActiveUser, void>({
      query: () => ({ url: '/api/current_user' }),
    }),
  }),
});
